import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getInvoices: async (context, query) => {
      let cashier = query.cashier;
      let limit = query.limit;
      let invNum = query.invoice;
      let paymentType = query.type;
      let isSmartInvoice = query.isSmartInvoice;
      let isRefund = query.isRefund;

      console.log("query data ", query);

      let payload = {
        ...context.getters.getTimeFrame,
        limit,
        invNum,
        cashier,
        paymentType,
        isRefund,
        isSmartInvoice
      };
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      let storeDB = store.StoreDB;
      console.log("DB Name", storeDB);

      let headers = {
        DB: storeDB ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `invoice/search` + queryString, {
          headers,
        })
        .then(({ data }) => {
          console.log("invoices", data);
          return data;
        })
        .catch((err) => errorHandler.tomcatError(err));
    },

    //printing functions
    printFranchiseTurnoverPDF: async (context) => {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return;
      let group = stores[0].Group;

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
      };
      return axios
        .get(docsApi + `stocks/export/pdf/franchiseTurnovers` + queryString, {
          headers,
          responseType: `blob`,
        })
        .then((response) => openFile(response, `Franchise TurnOver PDF`))
        .catch((err) => {
          console.error("Error fetching invoices:", err);
          errorHandler.tomcatError(err);
          throw err;
        });
    },

    printFranchiseTurnoverCSV: async (context) => {
      let payload = {
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem(`stores`));
      if (stores.length === 0) return;
      let group = stores[0].Group;

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
      };
      return axios
        .get(docsApi + `stocks/export/excel/franchiseTurnovers` + queryString, {
          headers,
          responseType: `blob`,
        })
        .then((response) => openFile(response, `Franchise TurnOver PDF`))
        .catch((err) => {
          console.error("Error fetching invoices:", err);
          errorHandler.tomcatError(err);
          throw err;
        });
    },
  },
};
